/**
 * returns the index of the targettedTab within the listOfTabs.  Returns -1 if targettedTab
 * cannot be found.
 * @param   {Object}   targettedTab the html element to find the index of within listOfTabs.
 * @param   {NodeList} listOfTabs   the NodeList containing targettedTab.
 * @returns {Number}                the targettedTab's index within listOfTabs.
 */
const getTargettedTabIndex = (targettedTab, listOfTabs) =>
  Array.from(listOfTabs).indexOf(targettedTab);

export default getTargettedTabIndex;
